module.exports = __webpack_public_path__ + "img/quali-banner-1920.20228899.jpg";